module.exports = __webpack_public_path__ + "static/media/tl.1ca6ce2c.svg";